import { getLinkDetailsEnterprise } from "@/utils/utilities";

const GlobalBanner = ({ data }) => {
    const banner = data?.[0] || {};
    if (!banner?.enable_banner) return null;

    const textConfig = banner?.global_banner_text;
    const linkConfig = banner?.global_banner_link;
    const {
        linkUrl,
        linkTarget,
        ariaLabel,
        dataLinkInfo,
        aria_describedby,
        linkID,
        linkTitle,
        onClick,
        role
    } = linkConfig?.link_reference?.[0] ? getLinkDetailsEnterprise(linkConfig?.link_reference?.[0]) : {};
    const classes = `col-12 col-lg-11 global-message px-2 py-1 justify-content-center ${textConfig?.enable_for_mobile ? "d-block" : "d-none"} ${textConfig?.enable_for_desktop ? "d-lg-block" : "d-lg-none"}`;

    return (
        <div
            id="global-alert"
            className="global-alert row mx-auto justify-content-lg-end d-flex"
        >
            <div className={classes}
                dangerouslySetInnerHTML={{
                    __html: textConfig?.text_html_css || "",
                }}
            >
            </div>
            {linkConfig?.enable_for_desktop && <div className="col-lg-1 px-2 py-1 global-alert-link d-none d-lg-flex align-items-center justify-content-end">
                <a
                    href={linkUrl || "#"}
                    data-link-info={dataLinkInfo}
                    target={linkTarget}
                    aria-labelledby={ariaLabel}
                    className="global-alert-link trackContent"
                    rel={linkTarget === "_blank" ? "noopener noreferrer" : undefined}
                    id={linkID}
                    role={role}
                    onClick={onClick}
                    aria-describedby={aria_describedby}
                >
                    {linkTitle}
                </a>
            </div>}
        </div>
    );
};

export default GlobalBanner;